<mat-dialog-content>
    <markdown [data]="ObjData.markdownText"></markdown>
</mat-dialog-content>
